
import { buildApi, get, post, put, destroy } from 'redux-bees';
import store from '../Store';

const apiEndpoints = {
  login: { method: post, path: ':locale/users/login' },
  getUserProfile: { method: get, path: ':locale/users/:id' },
  updateUser: { method: put, path: ':locale/users/:id' },
  getInvoices: { method: get, path: ':locale/users/:id/invoices' },
  getInvoice: { method: get, path: ':locale/users/:id/invoices/:invoiceID' },
  getProducts: { method: get, path: ':locale/users/:id/userProducts' },
  getProduct: { method: get, path: ':locale/users/:id/userProduct/:productID' },
  freezeProduct: { method: post, path: ':locale/users/:id/userProduct/:productID/freeze' },
  getFreezes: { method: get, path: ':locale/users/:id/userProduct/:productID/freeze' },
  updateFreeze: { method: put, path: ':locale/users/:id/userProduct/:productID/freeze' },
  deleteFreeze: { method: destroy, path: ':locale/users/:id/userProduct/:productID/freeze' },
  deleteFutureFreeze: { method: destroy, path: ':locale/users/:id/userProduct/:productID/freeze/:freezeID' },
  getConsumption: { method: get, path: ':locale/users/:id/userProduct/:productID/consumption' },
  getVoiceMailInfo: { method: get, path: ':locale/users/:id/userProduct/:productID/voiceMail' },
  updateVoiceMail: { method: put, path: ':locale/users/:id/userProduct/:productID/voiceMail' },
  changePassword: { method: put, path: ':locale/users/:id/password' },
  postMispari: { method: post, path: ':locale/users/:id/userProduct/:productID/mispari' },
  updateMispari: { method: put, path: ':locale/users/:id/userProduct/:productID/mispari' },
  getMispari: { method: get, path: ':locale/users/:id/userProduct/:productID/mispari' },
  deleteMispari: { method: destroy, path: ':locale/users/:id/userProduct/:productID/mispari' },
  getSentFaxes: { method: get, path: ':locale/users/:id/userProduct/:productID/fax' },
  postPaymentMethod: { method: post, path: ':locale/users/:id/paymentMethod' },
  postInvoicePayment: { method: post, path: ':locale/users/:id/invoices/payment' },
  setLineParams: { method: put, path: ':locale/users/:id/userProduct/:productID/lineParams' },
};

const config = {
  baseUrl: `${process.env.REACT_APP_API}`,
  configureHeaders(headers) {
    let token = store.getState().User.token;
    return {
      ...headers,
      'Authorization': `Bearer ${token}`,
    };
  }
};


export const api = buildApi(apiEndpoints, config);



// WEBPACK FOOTER //
// ./src/services/redux-beesConfig.js